module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('WebTemplate', {
    attrs: {
      "pagetitle": "转化分析",
      "tip": "设置好您关注的转化目标后，转化分析报告帮助您监测各转化目标的转化数据，衡量您网站的转化效果",
      "currentTab": _vm.currentTab,
      "total": _vm.total,
      "pg": _vm.pg,
      "ps": _vm.ps,
      "tablist": _vm.tablist,
      "customColumns": _vm.customColumns,
      "tableDataList": _vm.tableDataList,
      "hasCheckBox": _vm.hasCheckBox,
      "checkboxLength": _vm.checkboxLength,
      "sum": _vm.sum,
      "order": _vm.order,
      "legend": _vm.legend,
      "yAxis": _vm.yAxis,
      "chartXAxis": _vm.chartXAxis,
      "chartSeries": _vm.chartSeries,
      "tableClassname": "bluethead opt-table",
      "customIndice": _vm.customIndice,
      "twoIndiceShow": _vm.twoIndiceShow,
      "twoIndice": _vm.twoIndice
    },
    on: {
      "indiceChange": _vm.indiceChange,
      "tableUpdate": _vm.getDataFunc,
      "tablesorter": _vm.tablesorter
    }
  }, [_c('ul', {
    staticClass: "tab",
    slot: "tabview"
  }, _vm._l((_vm.tabViews), function(item) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('div', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.currentView === item.comp
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeViewTo(item.comp)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  })), _c('div', {
    staticClass: "nav-tabs",
    slot: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab,
      "currentTab": _vm.currentTab
    }
  }, [_c('div', {
    staticClass: "right-tab",
    slot: "extentTab"
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.tableTabTitle,
      "subtitle": ""
    }
  }) : _vm._e()], 1), _c('div', {
    slot: "common"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView !== 'system'),
      expression: "currentView !== 'system'"
    }],
    staticClass: "plan-nav"
  }, [_vm._v("选择二级维度："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdim),
      expression: "sdim"
    }],
    attrs: {
      "name": "secondaryDim",
      "options": _vm.sdimOptions
    },
    domProps: {
      "value": (_vm.sdim)
    },
    on: {
      "input": function($event) {
        _vm.sdim = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.sdimChange($event)
      }
    }
  })], 1), _c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")])])])])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45118070", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45118070!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/conversion.vue
// module id = 748
// module chunks = 0